import { postFmsPrintPdf } from '#/api/fmsMgmt/printPdf';

/**
 * POST `/fms/vouchers/{id}/print`：PDF 含憑證資料與目前有效附件。
 * 由請款單開啟的關聯憑證須帶 `paymentRequestId`（→ `payment_request_id`）。
 */
export async function printVoucher(id, { paymentRequestId, voucherNo } = {}) {
  return postFmsPrintPdf(`/fms/vouchers/${id}/print`, {
    params: paymentRequestId ? { payment_request_id: paymentRequestId } : undefined,
    fallbackFilename: `${voucherNo || 'voucher'}.pdf`,
  });
}
